import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgGrid = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M4 22C3.45 22 2.97933 21.8043 2.588 21.413C2.196 21.021 2 20.55 2 20V4C2 3.45 2.196 2.979 2.588 2.587C2.97933 2.19567 3.45 2 4 2H20C20.55 2 21.021 2.19567 21.413 2.587C21.8043 2.979 22 3.45 22 4V20C22 20.55 21.8043 21.021 21.413 21.413C21.021 21.8043 20.55 22 20 22H4ZM4 16V20H8V16H4ZM10 16V20H14V16H10ZM16 20H20V16H16V20ZM4 14H8V10H4V14ZM10 14H14V10H10V14ZM16 14H20V10H16V14ZM8 4H4V8H8V4ZM10 8H14V4H10V8ZM16 8H20V4H16V8Z",
		fill: "currentColor"
	})
});
export default SvgGrid;
